import { decodeHtml } from '../lib/decode-html'

export default (() => {
  const symbols = {
    close: '&#x000D7;',
    back: '&#x02A2F;',
    down: '&#x025BE;',
    hamburger: '&#x2630;',
    //hamburger: '&#x2261;', // most support
    //hamburger: '&#x022EE;', // not a hamburger
    play: '&#x025B8;',
    signout: '&#x02297;',
  }

  for (var symbol in symbols) {
    symbols[symbol] = decodeHtml(symbols[symbol]);
  }

  return {
    ...symbols,
  }
})()



// WEBPACK FOOTER //
// ./src/common/assets/symbols.js